import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import messages from './IdCheckVerificationAction.messages';
import { FUNDING_STEP_ACTION } from '../../Funding.actions';
import { FundingStepActionButton } from '../fundingStepActionButton/FundingStepActionButton';
import { TFundingRequirementsSteps } from '../orderFundingRequirements';
import StepItem from '../stepItem/StepItem';

const mapDispatchToProps = (dispatch: Dispatch) => ({
    handleFundingStepAction: () => {
        dispatch({ type: FUNDING_STEP_ACTION, step: 'ONFIDO_VERIFICATION' });
    }
});

const IdCheckVerificationAction = ({
    status,
    handleFundingStepAction
}: {
    status: TFundingRequirementsSteps['0']['status'];
} & ReturnType<typeof mapDispatchToProps>) => {
    return (
        <StepItem
            title={<FormattedMessage {...messages.titleSingular} />}
            caption={<FormattedMessage {...messages.captionSingular} />}
            action={
                <FundingStepActionButton
                    actionMessage={<FormattedMessage {...messages.action} />}
                    pendingMessage={<FormattedMessage {...messages.pending} />}
                    status={status}
                    handleFundingStepAction={handleFundingStepAction}
                />
            }
        />
    );
};

// eslint-disable-next-line import/no-default-export
export default connect(null, mapDispatchToProps)(IdCheckVerificationAction);
